// NPM Imports
import React, { Fragment } from "react";

// Internal Imports
import { RevvGridCell } from "../../Components";

export default function UngroupedTable(props) {
  const { columns, currencySymbol, pinnedColumns, rows } = props;
  const productNameFld = pinnedColumns.find(col => col.name === "product_name")
    .field;

  return (
    <Fragment>
      <div className="rs-pinned-left-body">
        {rows.map((row, i) => (
          <div
            className="rs-row"
            row-id={row.rowMeta.id}
            row-name={row.rowData[productNameFld].cellData}
            key={row.rowMeta.id}>
            {pinnedColumns.map(col => (
              <RevvGridCell
                col={col}
                currencySymbol={currencySymbol}
                deleteRow={() => props.deleteRow(row)}
                index={i}
                key={col.field}
                onCellValueChanged={value =>
                  props.onCellValueChanged(i, value, row, col)
                }
                pricingPopUp={value => props.pricingPopUp(value, col, row, i)}
                readOnly={props.readOnly}
                row={row}
              />
            ))}
          </div>
        ))}
      </div>
      <div className="rs-body-viewport">
        {rows.map((row, i) => (
          <div
            className="rs-row"
            row-id={row.rowMeta.id}
            row-name={row.rowData[productNameFld].cellData}
            key={row.rowMeta.id}>
            {columns.map(col => (
              <RevvGridCell
                col={col}
                currencySymbol={currencySymbol}
                index={i}
                key={col.field}
                onCellValueChanged={value =>
                  props.onCellValueChanged(i, value, row, col)
                }
                pricingPopUp={value => props.pricingPopUp(value, col, row, i)}
                readOnly={props.readOnly}
                row={row}
              />
            ))}
          </div>
        ))}
      </div>
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/commonComponents/RevvGrid/Display/UngroupedTable/index.js